import React from 'react'
import { Divider,  Flex,  Stat, StatLabel, StatNumber } from '@chakra-ui/react'


export default function StatBox({ w, h, label, value, py, px, my, mx, m,mt, divider}) {
    return (
            <Flex position="relative " h="70px">
                <Stat
                mt={ mt ? mt : 0}
                py={ py ? py : 0}
                px={ px ? px : 0}
                // shadow={'md'}
                backgroundColor="white"
                borderLeft={[ "none","1px solid #DFE0EB"]}
                // rounded={'lg'}
                textAlign="center"
            >
                <StatLabel textColor="#9FA2B4">{label}</StatLabel>
                <StatNumber>{value}</StatNumber>
                {divider && <Divider data-testid="divider"/> }
            </Stat>
            </Flex>
    )
}
